<template>
    <a href="#" class="menu__item__link menu__lan__switcher" @click="changeLang(currentLang)">
        {{currentLang === languages[0].title ? languages[1].title : languages[0].title}}
    </a>
</template>

<script>

export default {
  name: 'ChangeLangBtn',
  data () {
    return {
      currentLang: '',
      secondLang: '',
      languages: [
        { title: 'РУ', code: 'ru' },
        { title: 'КГ', code: 'kg' }
      ]
    }
  },
  mounted () {
    const selectedLang = this.languages.find(el => el.code === JSON.parse(window.localStorage.getItem('schoolLang')))
    this.currentLang = selectedLang.title || this.languages[0].title
    this.$root.$i18n.locale = selectedLang.code
  },
  methods: {
    changeLang (lang) {
      console.log(lang)
      const data = lang === 'РУ' ? 'kg' : 'ru'
      console.log(data)
      window.localStorage.setItem('schoolLang', JSON.stringify(data))
      this.$router.go(0)
    }
  }
}
</script>
<style lang="scss">

</style>
